<script lang="ts">
  import { getPriceHTMLOrFree } from '../../../common/util';

  export let data;
</script>

<section class="pdp-vas-readonly-row">
  <div class="label">{data?.vasType?.label}</div>
  <div class="price">
    {@html getPriceHTMLOrFree(data?.servicePrice?.value)}
  </div>
</section>

<style lang="scss">
  .pdp-vas-readonly-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    line-height: 16px;
    font-weight: 400;

    .label {
      max-width: 60%;
    }
  }
</style>
